import * as React from 'react'
import Toolbar, { ToolbarProps } from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'
// import Button from '@mui/material/Button'
import logo from '../assets/img/logo_safefleet.png'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import BarUserMenu from './BarUserMenu'
import { useSelectedUser } from '../hooks/user'
import CompanySelector from './CompanySelector'
import { spaces } from '../theme'
import avatarIcon from '../assets/img/avatar.svg'
import { SectionTitle } from './Text'
import { useNavigate } from 'react-router-dom'
import RssFeedComponent from './RssFeed'
import rssFeedAvailableSubDomains from '../utils/rssFeedAvailableSubDomains'
// import axios from 'axios'
// import { useSelector } from 'react-redux'
// import { auth } from '@safefleet/react-common'
// import instancesServer from '../utils/instancesServer'

type AppBarAvatarProps = {
    avatar: string
}

const StyledToolbar = styled(Toolbar)<ToolbarProps>(({ theme }) =>{
    return {
        height: theme.custom.appBar.height,
    }
})

const useNavigateToRoot = () => {

    const navigate = useNavigate()

    return React.useCallback(() => {
        navigate('/')
        window.location.reload()
    }, [navigate])
}
const Logo = ({ onClick }:{onClick?: ()=> any}) => {
    return (
        <img
            src={logo}
            alt="Logo"
            style={{
                height      : "70%",
                marginRight : 50,
                cursor      : 'pointer',
            }}
            onClick={onClick}
        />
    )
}

// type AppBarButtonProps = {
//     text: string,
//     icon?: any,
//     active?: boolean
//     onClick?: () => any,
// }


// const AppBarButton: React.FC<AppBarButtonProps> = ({ text, icon,onClick, active }) => {

//     return (
//         <Button
//             color="secondary"
//             onClick={onClick}
//             sx={{
//                 flexDirection   : "column",
//                 paddingTop      : `${spaces.headerLine[2]}px`,
//                 height          : '100%',
//                 backgroundColor : active ? '#EDEDED' : 'white',
//                 marginLeft      : 3,
//                 display         : { xs: "none", sm: "flex" },
//             }}
//         >
//             {icon}
//             <span style={{ fontSize: 12, fontWeight: active ? 'bold' : 'normal', marginTop: 7 }}>
//                 {text}
//             </span>
//         </Button>
//     )
// }

const AppBarAvatar: React.FC<AppBarAvatarProps> = ({ avatar }) => (
    <Avatar src={avatar} sx={{ width: 45, height: 45 }} />
)

const getUserName = (user) => {
    const first_name = user?.first_name ?? ''
    const last_name = user?.last_name ?? ''

    return first_name + " " + last_name
}

const RssFeed = () => {
    const prefix = window.location.hostname.split('.')[0]

    if(rssFeedAvailableSubDomains.includes(prefix)) {
        return (
            <Box
                sx={{
                    display        : "flex",
                    flexDirection  : "column",
                    marginRight    : `${spaces.headerLine[2]}px`,
                    justifyContent : "flex-end",
                    alignItems     : "center",
                    marginTop      : "7px",
                }}
            >
                <RssFeedComponent />
            </Box>
        )
    } else {
        return <></>
    }
}

const SpaAppBar: React.FC = () => {

    const user = useSelectedUser()
    const avatar = user?.profile_photo || avatarIcon
    const userName = getUserName(user)
    // const prefixUrl = window.location.hostname.split('.')[0]
    // const authTokens: any = useSelector(auth.getJwtTokens)
    // const accessToken = authTokens.accessToken
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    // React.useEffect(() => {
    //     const serverUrl = instancesServer?.[prefixUrl]
    //     axios.get(
    //         `${serverUrl}/safeapi/api/reports/jasper-login-url`,
    //         { headers: { Authorization: `Bearer ${accessToken}` } }
    //     ).then((response) => {
    //         setJasperURL(response.data.login_url)
    //     })
    // }, [accessToken, prefixUrl])

    const goHome = useNavigateToRoot()

    return (
        <AppBar
            sx={{
                backgroundColor: "background.paper",

                zIndex  : (theme) => theme.zIndex.drawer + 1,
                padding : 0,
            }}
            position="fixed"
        >
            <StyledToolbar>
                <Logo onClick={goHome} />
                <Box
                    sx={{
                        flex           : 1,
                        display        : "flex",
                        flexDirection  : "row",
                        justifyContent : "flex-end",
                        height         : "100%",
                        alignItems     : "center",
                    }}
                >
                    <RssFeed />
                    <Box
                        sx={{
                            display        : { xs: "none", sm: "flex" },
                            flexDirection  : "column",
                            marginRight    : `${spaces.headerLine[2]}px`,
                            justifyContent : "flex-end",
                            alignItems     : "center",
                            marginTop      : "7px",
                        }}
                    >
                        <SectionTitle
                            sx={{
                                display   : "flex",
                                alignSelf : "flex-end",
                            }}
                        >
                            {userName}
                        </SectionTitle>
                        <CompanySelector />
                    </Box>
                    <Box
                        onClick={handleClick}
                    >
                        <AppBarAvatar avatar={avatar}/>
                    </Box>
                </Box>
                <BarUserMenu
                    open={open}
                    handleClose={handleClose}
                    anchorEl={anchorEl}
                    avatar={avatar}
                />
            </StyledToolbar>
        </AppBar>
    )
}

export default SpaAppBar
